import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { NAV_ROOT } from '../../constants';
import AppLogoFull from '../../assets/logo-full.svg';
import AppLogo from '../../assets/logo.png';

const MenuLogo = ({
  onClick = () => {},
  size = 'default'
}) => {
  return (
    <Link
      to={NAV_ROOT}
      className="header-logo align-items-end"
      onClick={onClick}
    >
      <img className="logo img-contain" src={size === 'default' ? AppLogo : AppLogoFull} alt="logo" />
    </Link>
  );
};

MenuLogo.propTypes = {
  onClick: PropTypes.func,
  size: PropTypes.string // full or default
};

export default MenuLogo;
